var mix=function mix(min,max,progress){return-progress*min+progress*max+min;};export{mix};